import React, { useState, useEffect } from 'react';
import { useIdle } from '../../context/IdleContext';

const IdleWarningModal = () => {
  const { showWarning, logout } = useIdle();
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    if (showWarning) {
      setSeconds(60);
      const interval = setInterval(() => {
        setSeconds(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            logout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [showWarning, logout]);

  if (!showWarning) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '450px' }}>
        <div className="modal-header">
          <h3>Session Expiring Soon</h3>
        </div>
        <div className="modal-body" style={{ textAlign: 'center' }}>
          <p style={{ fontSize: '18px', marginBottom: '16px' }}>
            You will be logged out in <strong>{seconds}</strong> second{seconds !== 1 ? 's' : ''} due to inactivity.
          </p>
          <p style={{ color: '#64748b' }}>Click anywhere to stay logged in.</p>
        </div>
        <div className="modal-footer" style={{ justifyContent: 'center' }}>
          <button className="btn btn-primary" onClick={() => window.dispatchEvent(new Event('click'))}>
            Stay Logged In
          </button>
        </div>
      </div>
    </div>
  );
};

export default IdleWarningModal;